<h2 mat-dialog-title>Is your PPA one of these?</h2>

<div mat-dialog-content>
  <p class="intro" *ngIf="canAddNew; else alreadyListed">
    These are listed already, and look like <strong>{{ data.name }}</strong>. Pick yours, so you join the corp members there.
  </p>
  <ng-template #alreadyListed>
    <p class="intro"><strong>{{ data.name }}</strong> is listed already. Pick it to join the corp members there.</p>
  </ng-template>

  <ul class="options">
    <li *ngFor="let ppa of data.suggestions">
      <button type="button" class="option" (click)="pick(ppa)">
        <span class="option__name">{{ ppa.name }}</span>
        <span class="option__meta">
          {{ ppa.type_of_ppa }}<ng-container *ngIf="ppaPlace(ppa.Locations?.[0]) as place"> · {{ place }}</ng-container>
        </span>
        <span class="option__meta" *ngIf="ppa.corper_count">
          {{ ppa.corper_count }} corp member{{ ppa.corper_count === 1 ? '' : 's' }} here
        </span>
        <span class="option__action">This one</span>
      </button>
    </li>
  </ul>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="primary" *ngIf="canAddNew" (click)="addNew()">None of these - add mine</button>
</mat-dialog-actions>
